import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import Logo, { Wordmark } from './Logo';
import { brand } from '../../mock';

const links = [
  { href: '/#about', label: 'About' },
  { href: '/#pathways', label: 'Care Model' },
  { href: '/#programs', label: 'Programs' },
  { href: '/#team', label: 'Team' },
  { href: '/#faq', label: 'FAQ' },
  { href: '/contact', label: 'Contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkTo = (href) => (href.startsWith('/#') && pathname !== '/' ? href.replace('/#', '/') : href);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'backdrop-blur-md bg-[rgba(247,243,236,0.85)] border-b border-[rgba(31,58,46,0.08)]' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 h-20 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center gap-3 group min-w-0 shrink">
          <div className="shrink-0">
            <Logo size={38} />
          </div>
          <div className="hidden sm:block min-w-0">
            <Wordmark />
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a key={l.href} href={linkTo(l.href)} className="btn-ghost text-sm">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <div className="hidden md:inline-flex">
            <Link to="/contact" className="btn-outline text-sm whitespace-nowrap">Get in touch</Link>
          </div>
          <a
            href={brand.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-sm whitespace-nowrap"
          >
            Book consultation
          </a>
          <button className="lg:hidden ml-1 p-2 rounded-full hover:bg-black/5 shrink-0" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream)]">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a key={l.href} href={linkTo(l.href)} onClick={() => setOpen(false)} className="py-2 text-green">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
